import { lazy, Suspense, useEffect } from 'react';

import { PageLayout } from '~components/page/PageLayout';
import useAppSelector from '~hooks/useAppSelector';
import useLabels from '~hooks/useLabels';
import { useNavigateToDefault } from '~hooks/useNavigateToPage';
import usePermissions from '~hooks/usePermissions';
import { selectAddonsIsTruckLabelingEnabled } from '~store/selectors';

const TruckLabelingExtension = lazy(() => import('~extension/truck-labeling/TruckLabeling'));

export default function TruckLabelingPage() {
  const navigateToDefault = useNavigateToDefault();
  const { hlPageTruckLabeling } = useLabels(['hlPageTruckLabeling']);

  // read store values
  const isEnabled = useAppSelector(selectAddonsIsTruckLabelingEnabled); //
  const { hasViewTruckLabelingOrdersPermission } = usePermissions();
  const hasPermission = hasViewTruckLabelingOrdersPermission;

  useEffect(() => {
    if (!isEnabled || !hasPermission) {
      navigateToDefault();
    }
  }, [navigateToDefault, hasPermission, hasViewTruckLabelingOrdersPermission, isEnabled]);

  return (
    <PageLayout title={hlPageTruckLabeling} className="page--truck-labeling">
      <div className="c-view__content relative flex-grow overflow-hidden">
        <div className="h-full">
          <Suspense fallback="loading">
            <TruckLabelingExtension />
          </Suspense>
        </div>
      </div>
    </PageLayout>
  );
}
